import { FunctionComponent } from 'react';

import styles from './Description.module.scss';

export type DescriptionProps = {
  children?: React.ReactNode;
  size?: 'sm' | 'smmd' | 'md' | 'lg';
  align?: 'left' | 'center';
  hasNoPadding?: boolean;
  color?: string;
  bold?: boolean;
};

type FC = FunctionComponent<DescriptionProps>;

const Description: FC = ({
  children,
  size = 'lg',
  align = 'left',
  hasNoPadding,
  color,
  bold = false,
}: DescriptionProps) => {
  return (
    <p
      className={[
        styles.description,
        styles[`font-${size}`],
        styles[`align-${align}`],
        styles[getPaddingClass()],
        styles[getBold()],
      ].join(' ')}
      style={{ color: `${color}` }}
    >
      {children}
    </p>
  );

  function getPaddingClass() {
    return hasNoPadding ? 'noPadding' : '';
  }

  function getBold() {
    return bold ? 'bold-text' : '';
  }
};

export default Description;
